(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    // click-directive to deactivate a task 
    module.directive('taskDeactivate', ['TaskService',
        function (TaskService) {
            var directive = {
                link: link,
                restrict: 'A',
                scope: {
                    task: '=' // task
                }
            };
            return directive;

            function link(scope, element) {

                // click listener
                element.on('click', function (e) {
                    deactivate();
                    e.preventDefault();
                    e.stopPropagation();
                });


                // deactivate task
                function deactivate() {
                    TaskService.showDeactivate(scope.task.id).then(function (result) {
                        if (result === undefined) { return; }
                        scope.task.isDeactivated = true;
                    });
                }


                // on destroy
                scope.$on("$destroy", function () {
                    element.off("click");
                });

            }
        }]);

})();